import React from 'react';
import ApplyMrRupya from '../components/apply-mrrupya';

const ApplyMrRupyaPage = () => {
  return <ApplyMrRupya />;
};

export default ApplyMrRupyaPage;
